export class ImageBase64ConversionException extends Error {
  constructor(message = 'Error while converting images to base64') {
    super(message);
  }
}
